// bully ignore[shared-imports-features: rule's applies predicate is always_ts_file (tools/bully/policy/src/rules/rules/shared_imports_features/mod.rs:19), not scoped to configured shared_layer_paths — it fires on every intra-feature import in this file, not something specific to this one. follow-up: .agents/follow-ups/bully-typescript-false-positive-rules.md]
import { SERIES_PALETTE } from 'features/charts-v2/services/series-color-palette'
import { ChartConfig } from 'features/charts-v2/types/chart-strategy'

export class ChartConfigService {
  private static instance: ChartConfigService
  private config: ChartConfig

  private constructor() {
    this.config = {
      colors: {
        primary: SERIES_PALETTE,
        pie: SERIES_PALETTE,
        histogram: SERIES_PALETTE,
        treemap: SERIES_PALETTE,
      },
      dimensions: {
        margin: {
          top: 20,
          right: 30,
          bottom: 60,
          left: 60,
        },
        minCellSize: {
          width: 8,
          height: 6,
        },
      },
      animation: {
        enabled: true,
        duration: 300,
      },
    }
  }

  public static getInstance(): ChartConfigService {
    if (!ChartConfigService.instance) {
      ChartConfigService.instance = new ChartConfigService()
    }
    return ChartConfigService.instance
  }

  public getConfig(): ChartConfig {
    return this.config
  }

  public getColors(type: keyof ChartConfig['colors']): string[] {
    return this.config.colors[type]
  }

  public getColor(type: keyof ChartConfig['colors'], index: number): string {
    const colors = this.config.colors[type]
    return colors[index % colors.length]!
  }

  public getMargin(): ChartConfig['dimensions']['margin'] {
    return this.config.dimensions.margin
  }

  public getMinCellSize(): ChartConfig['dimensions']['minCellSize'] {
    return this.config.dimensions.minCellSize
  }

  public isAnimationEnabled(): boolean {
    return this.config.animation.enabled
  }

  public getAnimationDuration(): number {
    return this.config.animation.duration
  }
}

export const chartConfig = ChartConfigService.getInstance()
